import Header from '../Header/Header'
import HomeBannerComponent from '../../molecules/HomeBannerComponent/HomeBannerComponent'
import CommonHeroSection from '../commonherosection/CommonHeroSection'

const HeroSection = () => {
  return (
    <CommonHeroSection>
      <div>
        <Header />
        <HomeBannerComponent />
      </div>
    </CommonHeroSection>
  )
}

export default HeroSection